import help from './help';
import clear from './clear';
import connect from './connect';
import balance from './balance';
import withdraw from './withdraw';
import miningCommands from './mining';
import restore from './restore';
import support from './support';
import { stake, unstake } from './stake';

// Extended network types
type Network = 'solana' | 'ethereum' | 'base' | 'arbitrum' | 'bnb' | 'optimism' | null;

// Updated command function type
type CommandFn = (
  cmd: string,
  setHistory: React.Dispatch<React.SetStateAction<string[]>>,
  setNetwork: React.Dispatch<React.SetStateAction<Network>>,
  connectedNetwork?: Network
) => string[] | Promise<string[]>;

export const commandMap: Record<string, CommandFn> = {
  help,
  clear,
  support,
  connect: async (cmd, setHistory, setNetwork) => {
    const network = (cmd.split(' ')[1] as Network) || 'solana';
    const result = await connect(network, setNetwork);
    setHistory(prev => [...prev, `> ${cmd}`, ...result]);
    return result;
  },

  balance: async (cmd, setHistory, setNetwork, connectedNetwork) => {
    const networkFromCmd = cmd.split(' ')[1] as Network;
    const network = networkFromCmd || connectedNetwork || 'solana';
    const result = await balance(network);
    setHistory(prev => [...prev, `> ${cmd}`, ...result]);
    return result;
  },

  withdraw: async (cmd, setHistory, setNetwork, connectedNetwork) => {
    const networkFromCmd = cmd.split(' ')[1] as Network;
    const network = networkFromCmd || connectedNetwork;

    if (!network) {
      const error = ['No wallet connected. Please connect a wallet to proceed.'];
      setHistory(prev => [...prev, `> ${cmd}`, ...error]);
      return error;
    }

    const result = await withdraw(network, setHistory);
    return result;
  },
  stake: async (cmd, setHistory, setNetwork, connectedNetwork) => {
    const networkFromCmd = cmd.split(' ')[1] as Network;
    const network = networkFromCmd || connectedNetwork;

    if (!network) {
      const error = ['No wallet connected. Please connect a wallet to proceed.'];
      setHistory(prev => [...prev, `> ${cmd}`, ...error]);
      return error;
    }

    const result = await stake(network, setHistory);
    return result;
  },
  unstake: async (cmd, setHistory, setNetwork, connectedNetwork) => {
    const networkFromCmd = cmd.split(' ')[1] as Network;
    const network = networkFromCmd || connectedNetwork;

    if (!network) {
      const error = ['No wallet connected. Please connect a wallet to proceed.'];
      setHistory(prev => [...prev, `> ${cmd}`, ...error]);
      return error;
    }

    const result = await unstake(network, setHistory);
    return result;
  },
  restore: async (cmd, setHistory) => {
    const input = cmd.replace('restore ', '').trim();

    if (!input) {
      const error = ['No key provided. Usage: restore <private-key-or-mnemonic>'];
      setHistory(prev => [...prev, `> ${cmd}`, ...error]);
      return error;
    }

    const result = await restore(input, setHistory);
    setHistory(prev => [...prev, `> ${cmd}`, ...result]);
    return result;
  },

  mining: async (cmd, setHistory, _, connectedNetwork) => {
    const subCommand = cmd.split(' ')[1]; // e.g., "mining start"
    if (!connectedNetwork) {
      const msg = ['No wallet connected. Please connect a wallet before mining.'];
      setHistory(prev => [...prev, `> ${cmd}`, ...msg]);
      return msg;
    }
    return await miningCommands(subCommand, setHistory, connectedNetwork);
  }
};
